<!-- start header area -->
@for (setting of (settings|slice:0:1); track $index) {
<header class="header--sticky header-one">
    <app-toaster *ngIf="showToast" [message]="toastMessage" [type]="toastType"></app-toaster>

    <div class="header-top header-top-one bg-1">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 d-xl-block d-none">
                    <div class="left">
                        @if(setting?.email){
                        <div class="mail">
                            <a [href]="'mailto:' + setting?.email">
                                <i class="fal fa-envelope"></i>{{ setting?.email }}
                            </a>

                        </div>
                        }

                        @if(setting?.unifiedNumber){
                        <div class="working-time text-light">
                            <i class="fal fa-phone"></i>
                            <a [href]="'tel:' + setting?.unifiedNumber" class="text-light">
                                {{ setting?.unifiedNumber }}
                            </a>
                        </div>
                        }
                    </div>
                </div>
                <div class="col-lg-6 d-xl-block d-none">
                    <div class="right">
                        <!-- <ul class="top-nav">
                            <li><a routerLink="/about-us">{{"MENU.ABOUT US" | translate}}</a></li>
                            <li><a routerLink="/articles">{{"MENU.POSTS" | translate}}</a></li>
                            <li><a routerLink="/news">{{"MENU.NEWS" | translate}}</a></li>
                            <li><a routerLink="/contact-us">{{"MENU.CONTACT" | translate}}</a></li>
                        </ul> -->
                        <ul class="social-wrapper-one">
                            @if(setting?.facebook){
                            <li> <a class="mr--0" [href]="setting?.facebook" target="_blank" rel="noopener noreferrer">
                                    <i class="fab fa-facebook-f"></i>
                                </a></li>
                            }
                            @if(setting?.instagram){
                            <li> <a class="mr--0" [href]="setting?.instagram" target="_blank" rel="noopener noreferrer">
                                    <i class="fab fa-instagram"></i>
                                </a>
                            </li>
                            }
                            @if(setting?.linkedIn){
                            <li><a class="mr--0" [href]="setting?.linkedIn" target="_blank" rel="noopener noreferrer"><i
                                        class="fab fa-linkedin-in"></i></a>
                            </li>
                            }


                        </ul>

                        <ul class="dropdown">
                            <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                {{"MENU.PROFILE"|translate}}

                                <img [src]="previewUrl || 'images/download.png'" alt="Profile Preview" width="45"
                                    height="70" class="mt-2"
                                    style="border-radius: 50%; cursor: pointer; display: block;" />

                            </button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item cursor-pointer" routerLink="/profile/details"
                                        *ngIf="isLoggedIn">
                                        {{"MENU.PROFILE"|translate}}</a>
                                </li>
                                <li>
                                    <a class="dropdown-item cursor-pointer" *ngIf="isLoggedIn"
                                        routerLink="/changePassword">
                                        {{"MENU.CHANGE_PASSWORD"|translate}}</a>
                                </li>
                                <li><a class="dropdown-item cursor-pointer" *ngIf="!isLoggedIn"
                                        routerLink="/register">{{"MENU.REGISTER"|translate}}</a>
                                </li>
                                <li><a class="dropdown-item cursor-pointer" *ngIf="!isLoggedIn"
                                        routerLink="/login">{{"MENU.LOGIN"|translate}}</a>
                                </li>
                                <li><a class="dropdown-item cursor-pointer" *ngIf="isLoggedIn"
                                        (click)="logout()">{{"MENU.LOGOUT"|translate}}</a>
                                </li>
                                <!-- <li><a class="dropdown-item cursor-pointer" routerLink="/profile/memberships"
                                        *ngIf="isLoggedIn">
                                        {{"MENU.MEMBERSHIP"|translate}}</a>
                                </li> -->
                            </ul>
                        </ul>

                        <div class="language-select top-nav">
                            <button (click)="toggleLang()" class="lang-btn">
                                {{ nextLang.toUpperCase() }}
                            </button>
                        </div>



                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="header-main-one bg-white">
        <div class="container">
            <div class="row">
                <div class="col-12">

                    <div class="main-header">
                        <div class="thumbnail logo">
                            <a routerLink="/home">
                                <img *ngIf="setting?.lightLogo?.path" [src]="setting.lightLogo.path | imageUrl"
                                    alt="{{setting?.lightLogo?.originalName}}">
                            </a>
                        </div>

                        <div class="full-w d-flex align-items-center justify-content-between">
                            <nav class="nav-main mainmenu-nav d-none d-xl-block">
                                <ul class="mainmenu">
                                    <!-- <li><a class="nav-item" href="index.html">{{"MENU.HOME" | translate}}</a></li> -->
                                    <li><a class="nav-item" routerLink="/about-us">{{"MENU.ABOUT US" | translate}}</a>
                                    </li>
                                    <li><a class="nav-item" routerLink="/articles">{{"MENU.POSTS" | translate}}</a></li>
                                    <li><a class="nav-item" routerLink="/news">{{"MENU.NEWS" | translate}}</a></li>
                                    <!-- <li><a class="nav-item" routerLink="/memberShip">{{"MENU.MEMBERSHIP" | translate}}</a>
                                    </li> -->
                                    <li class="has-droupdown">
                                        <!-- <li> -->
                                        <a class="nav-link" role="button" (click)="toggleSubmenu('conference')"
                                            [routerLink]="'/conferences'">{{"MENU.CONFERENCES" |
                                            translate}}</a>
                                        <ul class="submenu">
                                            <li>
                                                <a (click)="closeSidebar()" [routerLink]="['/conferences']"
                                                    [queryParams]="{ IsIncoming: true }">{{ 'CONFERENCE.COMING' |
                                                    translate }}</a>
                                            </li>
                                            <li>
                                                <a (click)="closeSidebar()" [routerLink]="['/conferences']"
                                                    [queryParams]="{ IsIncoming: false }">{{ 'CONFERENCE.PREVIOUS' |
                                                    translate }}</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="has-droupdown">

                                        <a class="nav-item">{{"MENU.SCHOOL" |
                                            translate}}</a>
                                        <!-- [routerLink]="'/Courses-and-Education'"
                                            [queryParams]="{ playlist: selectedPlaylist }" -->
                                        <ul class="submenu">
                                            @for (playlist of Playlists; track $index) {
                                            <li><a [routerLink]="['/Courses-and-Education']"
                                                    [queryParams]="{ playlist: playlist.id }">{{ playlist.name }}</a>
                                            </li>
                                            }
                                        </ul>
                                    </li>
                                    <li><a class="nav-item" routerLink="/branch">{{"MENU.ASSOCIATIONS" | translate}}</a>
                                    </li>

                                    <li><a class="nav-item" routerLink="/profile/memberships">
                                            {{"MENU.MEMBERSHIP"|translate}}</a>
                                    </li>

                                    <li><a class="nav-item" routerLink="/contact-us">{{"MENU.CONTACT" | translate}}</a>
                                    </li>

                                </ul>
                            </nav>
                            <div class="button-area">
                                <!-- <button id="lang-btn" class="rts-btn btn-primary-alta mr--20 mr_sm--5"><i>AR</i></button> -->
                                <button (click)="closeSidebar()" id="lang-btn" (click)="toggleLang()"
                                    class="rts-btn btn-primary-alta mr--20 mr_sm--5">
                                    {{ nextLang.toUpperCase() }}
                                </button>
                                <!-- <button id="search" class="rts-btn btn-primary-alta mr--20 mr_sm--5"><i
                                        class="far fa-search"></i></button> -->
                                <!-- <div class="search-input-area">
                                    <div class="container">
                                        <div class="search-input-inner">
                                            <div class="input-div">
                                                <input id="searchInput1" class="search-input" type="text"
                                                    placeholder="ابحث هنا">
                                                <button><i class="far fa-search"></i></button>
                                            </div>
                                            <div id="close" class="search-close-icon"><i class=""></i></div>
                                        </div>
                                    </div>
                                </div> -->
                                <button id="menu-btn" class="menu rts-btn btn-primary-alta mr_sm--5"
                                    (click)="toggleSidebar()">
                                    <img class="menu-dark" src="./images/icon/menu.png" alt="Menu-icon">
                                    <img class="menu-light" src="./images/icon/menu-light.png" alt="Menu-icon">
                                </button>


                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    </div>
</header>
<!-- End header area -->

<!-- ======================================================= -->
<!-- Side Bar Menu -->
<div id="side-bar" class="side-bar" [class.active]="isSidebarOpen">
    <button class="close-icon-menu" (click)="closeSidebar()">
        <i class="bi bi-x fs-1"></i>
    </button>

    <div class="rts-sidebar-menu-desktop">
        <a class="logo-1" routerLink="/">
            <img *ngIf="setting?.lightLogo?.path" [src]="setting.lightLogo.path | imageUrl"
                alt="{{setting?.lightLogo?.originalName}}">
        </a>

        <div class="body d-none d-xl-block">
            <p class="disc">{{setting?.name}}</p>

            <div class="get-in-touch">
                <div class="h6 title">{{"MENU.CONTACT" |translate}}</div>
                <div class="wrapper">
                    <div class="single">
                        <i class="fas fa-phone-alt"></i>
                        <a [href]="'tel:' + setting?.unifiedNumber">
                            {{ setting?.unifiedNumber }}
                        </a>
                    </div>

                    <div class="single"><i class="fas fa-envelope"></i>
                        <a [href]="'mailto:' + setting?.email">
                            {{ setting?.email }}
                        </a>
                    </div>
                    <div class="single"><i class="fas fa-globe"></i><a href="#">www.esrnm.com</a></div>
                    <div class="single">
                        <i class="fas fa-map-marker-alt"></i>
                        <a [href]="'https://www.google.com/maps?q=' + setting?.lat + ',' + setting?.long"
                            target="_blank">
                            {{ setting?.address }}
                        </a>
                    </div>

                </div>

                <div class="social-wrapper-two menu">
                    <a [href]="setting?.facebook" target="_blank" rel="noopener noreferrer">
                        <i class="fab fa-facebook-f"></i>
                    </a>

                    <a [href]="setting?.instagram" target="_blank" rel="noopener noreferrer">
                        <i class="fab fa-instagram"></i>
                    </a>

                    <a [href]="setting?.whatsapp" target="_blank" rel="noopener noreferrer">
                        <i class="fab fa-whatsapp"></i>
                    </a>
                </div>
            </div>
        </div>

        <div class="body-mobile d-block d-xl-none">
            <nav class="nav-main mainmenu-nav">
                <ul class="mainmenu">
                    <li><a class="nav-item" (click)="closeSidebar()" routerLink="/">{{"MENU.HOME" |translate}}</a></li>
                    <li><a class="nav-item" (click)="closeSidebar()" routerLink="/about-us"> {{"MENU.ABOUT US"
                            |translate}}</a></li>
                    <li><a class="nav-item" (click)="closeSidebar()" routerLink="/articles">{{"MENU.POSTS" |
                            translate}}</a></li>
                    <li><a class="nav-item" (click)="closeSidebar()" routerLink="/news">{{"MENU.NEWS" |
                            translate}}</a></li>
                    <!-- <li><a class="nav-item" (click)="closeSidebar()" routerLink="/memberShip">{{"MENU.MEMBERSHIP"
                            |translate}}</a></li> -->

                    <li class="has-droupdown" [class.open]="isSubmenuOpen['conference']">
                        <a class="nav-link" role="button" [routerLink]="'/conferences'"
                            (click)="toggleSubmenu('conference')">
                            {{"MENU.CONFERENCES" | translate}}
                        </a>
                        <ul class="submenu mb-submenu">
                            <li>
                                <a (click)="closeSidebar()" [routerLink]="['/conferences']"
                                    [queryParams]="{ IsIncoming: true }">Coming</a>
                            </li>
                            <li>
                                <a (click)="closeSidebar()" [routerLink]="['/conferences']"
                                    [queryParams]="{ IsIncoming: false }">Previous</a>
                            </li>
                        </ul>
                    </li>


                    <li class="has-droupdown" [class.open]="isSubmenuOpen['school']">
                        <a class="nav-link" role="button" (click)="toggleSubmenu('school')">
                            {{"MENU.SCHOOL" | translate}}
                        </a>
                        <!-- <a class="nav-item" (click)="closeSidebar()"
                            [routerLink]="'/Courses-and-Education'">{{"MENU.SCHOOL" |
                            translate}}</a> -->
                        <ul class="submenu mb-submenu">
                            @for (playlist of Playlists; track $index) {
                            <li><a [routerLink]="['/Courses-and-Education']"
                                    [queryParams]="{ playlist: playlist.id }">{{ playlist.name }}</a>
                            </li>
                            }
                        </ul>
                    </li>
                    <li class="has-droupdown" [class.open]="isSubmenuOpen['profile']">
                        <a class="nav-link" role="button" (click)="toggleSubmenu('profile')">
                            {{"MENU.PROFILE" | translate}} </a>
                        <ul class="submenu mb-submenu">
                            <li><a routerLink="/profile/details" class="cursor-pointer" (click)="closeSidebar()"
                                    *ngIf="isLoggedIn">{{"MENU.PROFILE"|translate}}</a>
                            </li>
                            <li>
                                <a (click)="closeSidebar()" class="pointer" *ngIf="!isLoggedIn"
                                    routerLink="/register">{{"MENU.REGISTER"|translate}}</a>
                            </li>
                            <li>
                                <a (click)="closeSidebar()" class="cursor-pointer" *ngIf="!isLoggedIn"
                                    routerLink="/login">{{"MENU.LOGIN"|translate}}</a>
                            </li>
                            <li>
                                <a (click)="closeSidebar()" class="cursor-pointer" *ngIf="isLoggedIn"
                                    routerLink="/changePassword">{{"MENU.CHANGE_PASSWORD"|translate}}</a>
                            </li>
                            <li>
                                <a class="cursor-pointer" *ngIf="isLoggedIn"
                                    (click)="handleLogout()">{{"MENU.LOGOUT"|translate}}</a>
                            </li>
                            <!-- <li><a (click)="closeSidebar()" class="dropdown-item cursor-pointer"
                                    routerLink="/profile/memberships" *ngIf="isLoggedIn">
                                    {{"MENU.MEMBERSHIP"|translate}}</a>
                            </li> -->

                        </ul>
                    </li>


                    <li><a (click)="closeSidebar()" class="nav-item" routerLink="/branch">{{"MENU.SUB ASSOCIATIONS" |
                            translate}}</a>
                    </li>


                    <li><a (click)="closeSidebar()" class="nav-item" routerLink="/profile/memberships">
                            {{"MENU.MEMBERSHIP"|translate}}</a>
                    </li>

                    <li><a (click)="closeSidebar()" class="nav-item" routerLink="/contact-us">{{"MENU.CONTACT" |
                            translate}}</a>
                    </li>
                </ul>



            </nav>

            <div class="social-wrapper-two menu mobile-menu">
                <a (click)="closeSidebar()" [href]="setting?.facebook" target="_blank" rel="noopener noreferrer">
                    <i class="fab fa-facebook-f"></i>
                </a>

                <a (click)="closeSidebar()" [href]="setting?.twitter" target="_blank" rel="noopener noreferrer">
                    <i class="fab fa-twitter"></i>
                </a>

                <a (click)="closeSidebar()" [href]="setting?.instagram" target="_blank" rel="noopener noreferrer">
                    <i class="fab fa-instagram"></i>
                </a>

                <a (click)="closeSidebar()" [href]="setting?.whatsapp" target="_blank" rel="noopener noreferrer">
                    <i class="fab fa-whatsapp"></i>
                </a>

            </div>
        </div>
    </div>
</div>
}